<template>
  <div class="upgrade">
    <el-row class="line button">
      <el-button icon="el-icon-circle-plus-outline"
                 size="small" @touchstart="openDialog('add')" @click="openDialog('add')">
        新增策略
      </el-button>
    </el-row>
    <ul v-if="upgradeList!=''">
      <li :key="item.id" v-for="item in upgradeList">
        <alarm-upgrade-comp :upgradeData="item" @init="getList" @openDialog="openDialog"></alarm-upgrade-comp>
      </li>
    </ul>
    <no-tactics :name="'告警升级'" @add="() => openDialog('add')" style="text-align: center;margin-top: 10%"
                v-else></no-tactics>

    <function-dialog-component
      :close-click="false"
      :dialog-title="title"
      :dialogVisible.sync="visible"
      @dialogClose="dialogClose"
      center
      width="51vw">
      <div slot="content"
           class="dialog-padding"
           style="height: 55vh;overflow-y: auto">
        <upgrade-details :actionList="data.alarmUpgradeActionList" v-if="operation === 'detail'"></upgrade-details>
        <upgrade-strategy :key="'strategy-form-' + strategyFormKey"
                          :accountList="accountList"
                          :spaceTree="spaceTree"
                          :strategyData="data"
                          @receiveData="receiveData"
                          v-if="operation === 'add' || operation === 'edit' ">
        </upgrade-strategy>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;">
        <el-button @touchstart="dialogClose" @click="dialogClose" size="mini">关 闭</el-button>
        <el-button @touchstart="commit" @click="commit" size="mini" type="primary" v-if="operation !== 'detail'">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import AlarmUpgradeComp from "@/views/basic_operations/strategy/alarm_convergence/AlarmUpgradeComp";
import UpgradeStrategy from "@/views/basic_operations/strategy/alarm_convergence/UpgradeStrategy";
import {getSpaceTreeData, getTreeHaveDisabled} from "@/network/space-info";
import { getList, saveOrUpdate} from "@/network/alarm-convergence";
import {getAccountList} from "@/network/account";
import NoTactics from "@/components/NoTactics";
import {getDeviceCategoryList} from "@/network/device-category";
import {getBySpaceIdAndTypId} from "@/network/device-info";
import {listByDeviceId} from "@/network/device-measuring-point";

export default {
  name: "AlarmUpgrade",
  components: {
    FunctionDialogComponent, AlarmUpgradeComp, UpgradeStrategy, NoTactics
  },
  inject: ['reload'],
  data() {
    return {
      upgradeList: [],
      visible: false,
      edit: true,
      operation: '',
      title: '新增策略',
      showBtn: false,
      strategyData: null,
      spaceId: null,
      // 空间树
      spaceTree: [{
        value: '',
        label: ''
      }],
      data: {},
      accountList: [],
      deviceCategoryList: [],
      categoryId: null,
      deviceList: [],
      deviceId: null,
      pointList: [],
      pointId: null,
      strategyFormKey: 0,
    }
  },
  created() {
    this.getList();
    this.getSpaceTreeData();
    this.getAccountList();
    // 获取设备类型
    this.getDeviceCategoryList();
  },
  methods: {
    changeSpace() {
      this.pointId=null
      this.deviceId=null
      this.pointList=[]
      this.getList()
      this.getDeviceList();
    },
    // 获取设备类型
    getDeviceCategoryList() {
      getDeviceCategoryList().then(res => {
        if (res.code === 0) {
          this.deviceCategoryList = res.data;
          return;
        }
      });
    },
    changeCategory() {
      this.pointId=null
      this.deviceId=null
      this.pointList=[]
      this.getList()
      this.getDeviceList();
    },
    // 获取设备
    getDeviceList() {
      getBySpaceIdAndTypId(this.spaceId, this.categoryId).then(res => {
        this.deviceList = res.data
      });
    },
    changeDevice(){
      this.pointId=null
      this.getList()
      this.getPointList();
    },
    //  获取设备的测点
    getPointList() {
      this.pointList=[]
      listByDeviceId(this.deviceId).then(res => {
        if (res.code === 0) {
          this.pointList=res.data
        }
      })
    },
    getList() {
      getList(this.spaceId,this.categoryId,this.deviceId,this.pointId).then(res => {
        console.log(res);
        this.upgradeList = res.data
      })
    },
    onMouseOver() {
      this.showBtn = true
    },
    onMouseLeave() {
      this.showBtn = false
    },
    openDialog(operation, data) {
      this.operation = operation;
      if (operation === 'add') {
        this.strategyFormKey += 1;
        this.title = '新增策略';
        this.strategyData = null;
        this.data = {
          alarmUpgradeActionList: [{
            startTime: "",
            time: "",
            intervalTime: "",
            noticeAccountIds: [],
            notifyTypeCodes: []
          }]
        };
        this.visible = true;
        return;
      }
      if (operation === 'detail') {
        if (data) this.data = data;
        this.title = data.spaceName + "-" + data.deviceCategoryName + "-" + (data.deviceName ? data.deviceName : "全部设备")
          + "-" + (data.devicePointName ? data.devicePointName : "全部测点");
        this.visible = true;
        return;
      }
      // 编辑：卡片数据可能不带全量 details/targets（列表带筛选时更甚），再拉一遍无筛选列表合并
      this.strategyFormKey += 1;
      this.title = '编辑策略';
      const defaultActions = () => [{
        startTime: "",
        time: "",
        intervalTime: "",
        noticeAccountIds: [],
        notifyTypeCodes: []
      }];
      const clicked = data ? { ...data } : {};
      if (!clicked.alarmUpgradeActionList) {
        clicked.alarmUpgradeActionList = defaultActions();
      }
      this.data = clicked;
      this.strategyData = { ...clicked };
      this.visible = true;
      if (clicked.id) {
        getList(null, null, null, null).then((res) => {
          if (res.code !== 0 || !Array.isArray(res.data)) return;
          const row = res.data.find((x) => x.id === clicked.id);
          if (!row) return;
          const merged = { ...clicked, ...row };
          if (!merged.alarmUpgradeActionList) {
            merged.alarmUpgradeActionList = defaultActions();
          }
          this.data = merged;
          this.strategyData = merged;
          this.strategyFormKey += 1;
        });
      }
    },

    //获取级联空间
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          this.spaceTree = getTreeHaveDisabled(res.data);
        }
      });
    },
    //数据接收
    receiveData(data) {
      const prev = this.strategyData || this.data || {};
      this.strategyData = { ...prev, ...data };
      // 确保alarmUpgradeActionList属性存在
      if (!this.strategyData.alarmUpgradeActionList) {
        this.strategyData.alarmUpgradeActionList = [];
        this.strategyData.alarmUpgradeActionList.push({
          startTime: "",
          time: "",
          intervalTime: "",
          noticeAccountIds: [],
          notifyTypeCodes: []
        });
      }
    },
    //数据保存
    commit() {
      const payload = this.strategyData;
      if (!payload) {
        this.$message.warning('表单未就绪，请稍候再试');
        return;
      }
      if (payload.id) {
        this.editUpgrade();
      } else {
        this.saveUpgrade();
      }
    },

    //新增策略
    saveUpgrade() {
      saveOrUpdate(this.strategyData).then(res => {
        if (res.code === 0) {
          this.$message.success("新增成功!")
        } else {
          this.$message.error("新增失败!")
        }
        this.visible = false;
        this.reload();
      })
    },
    //修改策略
    editUpgrade() {
      saveOrUpdate(this.strategyData).then(res => {
        if (res.code === 0) {
          this.$message.success("编辑成功!")
        } else {
          this.$message.error("编辑失败!")
        }
        this.visible = false;
        this.reload();
      })
    },
    //获取用户列表
    getAccountList() {
      this.accountList = [];
      getAccountList().then(res => {
        if (res.code === 0) {
          this.accountList = res.data;
        }
      })
    },
    dialogClose() {
      this.visible = false;
      this.data = {};
      this.strategyData = null;
    }
  },
  watch: {
    form: {
      handler(newV) {
        // 转换为API需要的格式
        const submitData = {
          id: this.strategyData?.id,
          alarmContent: newV.alarmContent,
          timeRange: newV.timeRange,
          duration: newV.duration,
          alarmConvergenceSettingDetails: newV.alarmConvergenceSettingDetails
        };
        
        this.$emit('receiveData', submitData);
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.upgrade {
  padding: 15px 10px;
}

.upgrade ul {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}

.upgrade li {
  list-style: none;
  width: 320px;
  height: 220px;
  margin: 10px;
  background-color:  rgba(41, 155, 255, .1);
  transition: all 0.3s;
}

.line.button {
  margin-bottom: 20px;
}
</style>
